import { render } from "./AliView.vue?vue&type=template&id=c8785cf2&scoped=true"
import script from "./AliView.vue?vue&type=script&lang=js"
export * from "./AliView.vue?vue&type=script&lang=js"

import "./AliView.vue?vue&type=style&index=0&id=c8785cf2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8785cf2"]])

export default __exports__